import { Contract } from '../../domain/entities/contract-entity';
import { Delete } from '../../domain/entities/delete-entity';
import { ContractRepository } from '../../domain/repositories/contract-repository';
import { createContract } from '../datasources/create-contract';
import { deleteContract } from '../datasources/delete-contract';
import { getContracts } from '../datasources/get-contracts';

export class ContractRepositoryImpl implements ContractRepository {
  async CreateContract(promisor_id: string, promisee_id: string): Promise<Contract> {
    const { id, promisor, promisee } = await createContract(promisor_id, promisee_id);

    return new Contract(id, promisor, promisee);
  }

  async GetContracts(client_id: string): Promise<Contract[]> {
    const contracts = await getContracts(client_id);

    return contracts.map(
      (contract: any) => new Contract(contract.id, contract.promisor, contract.promisee)
    );
  }

  async GetContract(client_id: string, contract_id: string): Promise<Contract> {
    throw new Error(`Method not implemented. ${client_id} ${contract_id}`);
  }

  async DeleteContract(contract_id: string): Promise<Delete> {
    const result = await deleteContract(contract_id);

    return new Delete(result.id, result.deleted);
  }
}
